import styled, { css } from 'styled-components';

import { styledTypography } from '@pkg/primitives';

import { tokens } from '../../tokens';

interface StyledMilestoneProps {
    $sticky?: boolean;
}

export const StyledMilestone = styled.div<StyledMilestoneProps>`
    display: grid;
    place-content: center;
    place-items: center;
    gap: ${tokens.milestone.gap}px;
    padding-left: ${tokens.segment.gutter}px;
    text-align: center;

    ${({ $sticky }) =>
        $sticky &&
        css`
            // These styles are required to help keep the <Milestone />
            // from breaking the layout when there are too many ticks.
            position: sticky;
            right: ${tokens.milestone.stickyOffset}px;
        `};
`;

export const Price = styled.p`
    ${styledTypography.allianceBase};
    font-size: ${tokens.milestone.price.fontSize}px;
    font-weight: 900;
    // font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
    color: white;
`;

export const Code = styled.p`
    ${styledTypography.allianceBase};
    font-size: ${tokens.milestone.code.fontSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.6);
`;
